import React from 'react';

/**
 * Header avec barre de progression pour l'onboarding
 */
export default function ProgressHeader({
  currentStep,
  totalSteps = 6,
  message,
  onBack,
  showBack = false,
}) {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="sticky top-0 bg-[#F0FDFA] z-10 pb-4">
      {/* Message et numéro d'étape */}
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-2">
          {showBack && (
            <button
              onClick={onBack}
              className="p-2 -ml-2 rounded-full hover:bg-white/50 transition-colors"
            >
              <svg 
                className="w-5 h-5 text-gray-600" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M15 19l-7-7 7-7" 
                />
              </svg>
            </button>
          )}
          <span className="text-[#059669] font-medium text-lg">{message}</span>
        </div>
        
        <div className="bg-[#D1FAE5] px-3 py-1 rounded-full text-sm font-medium text-[#059669]">
          Étape {currentStep}/{totalSteps}
        </div>
      </div>

      {/* Barre de progression */}
      <div className="px-4">
        <div className="h-2 bg-[#E5E7EB] rounded-full overflow-hidden">
          <div
            className="h-full bg-[#059669] rounded-full transition-all duration-500 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
}
